export default "__VITE_ASSET__66b6e9bf__"